import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=9c4ff1fe&"
import script from "./PricingTable.vue?vue&type=script&lang=js&"
export * from "./PricingTable.vue?vue&type=script&lang=js&"
import style0 from "./PricingTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c4ff1fe')) {
      api.createRecord('9c4ff1fe', component.options)
    } else {
      api.reload('9c4ff1fe', component.options)
    }
    module.hot.accept("./PricingTable.vue?vue&type=template&id=9c4ff1fe&", function () {
      api.rerender('9c4ff1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricing/PricingTable.vue"
export default component.exports